import { render, staticRenderFns } from "./InquiriesDialog.vue?vue&type=template&id=94e7de70&scoped=true&"
import script from "./InquiriesDialog.vue?vue&type=script&lang=js&"
export * from "./InquiriesDialog.vue?vue&type=script&lang=js&"
import style0 from "./InquiriesDialog.vue?vue&type=style&index=0&id=94e7de70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e7de70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VDialog,VProgressCircular})
